import React, { useEffect } from 'react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import Main from './Main'

import TerminalMusicEditor from './TerminalMusicEditor';
import GaryBuseyLookALikes from './GaryBuseyLookALikes';
import GetLucky3000 from './GetLucky3000'
import '../App.css';




const App = () => {

  useEffect(() => { document.body.style.backgroundRepeat = "no-repeat"}, [])
  useEffect(() => { document.body.style.display = 'flex'}, []) 
  useEffect(() => { document.body.style.textAlign = 'center'}, []) 
  

  return (



    <div>


    <Router>
    {/* <Link style={textStyles} to="/">Home</Link>
    <Link style={textStyles} to="/about">About</Link> */}


        <Switch>

            <Route exact path='/'>

              <Main />


            </Route>


            <Route path='/getlucky3000'>
                <GetLucky3000 />
            </Route>
            <Route path='/garybuseylookalikes'>
                <GaryBuseyLookALikes />
            </Route>
            <Route path='/musicterminalapp'>
                <TerminalMusicEditor />
            </Route>
        </Switch>
    </Router>
    </div>


  )
}

export default App;
